
import { Autocomplete, Box, Button, CircularProgress, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField, Typography } from '@mui/material'
import axios from 'axios'
import _, { set } from 'lodash'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import { useStyle } from '../../billing/style'
import CustomTable from '../customTable'
import { Helmet } from 'react-helmet-async'
import dayjs from 'dayjs'
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from 'moment'
import * as XLSX from 'xlsx';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import { Save } from '@mui/icons-material'

const OverAllBranchWiseReport = () => {
    const dispatch = useDispatch()
    const classes = useStyle()
    const [data, setData] = useState([])
    // const [data, setData] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [catData,setCatData] = useState([])
    const [subData,setSubData] = useState([])
    const [headData, setHeadData] = useState([])
    const [typeData, setTypeData] = useState([])
    const [supplier, setSupplier] = useState([]);
    const [outletName , setOutletName]=useState([])
    const [loading, setLoading] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0); // overall amount in footer
    const [totalFlag, setTotalFlag] = useState(false); // set the total flag true
    const [categoryId, setCategoryId] = useState(0);
    const [subCategoryId, setSubCategoryId] = useState(0);  // or a default subcategory ID
    const [typeId, setTypeId] = useState(0);  // or a default subcategory ID
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [selectedHead, setSelectedHead] = useState(null);
    const [selectedType, setSelectedType] = useState(null); // For selected Autocomplete option
    const [typeOptions, setTypeOptions] = useState([]); // Array for Autocomplete options
    const [categoryError, setCategoryError] = useState(''); // Track the category error message

    const roleId = localStorage.getItem("role_id")
console.log(typeOptions,"typeOptions");

    const outletId = localStorage.getItem('outlet_id')
  const[cust, setCust] = useState(null)
   const [allSubData, setAllSubData] = useState([]);

    const [options, setOptions] = useState({
        customer:null,
        // head: null,
        // type: null,
        head: [],
         type: [],

        category : [],
        subCategory : [],
        fromDate: dayjs().startOf('month').format('YYYY-MM-DD'), // Month start date
    // toDate: dayjs().endOf('month').format('YYYY-MM-DD')      // Month end date
        // fromDate: moment().subtract(1 , 'years' ).format(),
        toDate :  moment().format()
    })

console.log(options,"options");

// function handleOptions(value, name,) {
//   console.log(name, value,"checks");  // Log the selected option for debugging
//   setOptions((prev) => ({ ...prev, [name]: value }));
//   // setOptions((prev) => ({ ...prev, subCategory: [], head: [], type: [] })); // Set to an empty array
// // Clear the error message whenever category is changed
// if (name === "category") {
//   setCategoryError(''); // Reset error when category is selected
// }

// if (name === "category" && !value) {
//   setCategoryError('Category is required'); // Show error if category is not selected
// } else {
//   setCategoryError(''); // Reset error if a value is selected
// }
//   if (name === "category") {
//     // Reset dependent dropdowns when category changes
//     setOptions((prev) => ({ ...prev, subCategory: null, head: null, type: null }));
//     filterSubCategories(value ? value.id : null);  // Update subcategories
//   } else if (name === "subCategory") {
//     const selectedCategoryId = options.category ? options.category.id : null;
//     const selectedSubCategoryId = value ? value.id : null;

//     if (selectedCategoryId && selectedSubCategoryId) {
//       getHead(selectedCategoryId, selectedSubCategoryId); // Fetch heads after selecting category & subcategory
//     }
//   } else  {
//     setHeadData([]); // Clear head options when subcategory is empty
//     // setOptions((prev) => ({ ...prev, head_name: null })); // Reset selected brand option to null

//   }
// }
// function handleOptions(value, name) {
//   console.log(name, value, "checks"); // Debugging log for selected option
//   setOptions((prev) => ({ ...prev, [name]: value }));

//   if (name === "category") {
//     setCategoryError(''); // Clear any category error
//     setOptions((prev) => ({ ...prev, subCategory: [], head: null, type: null })); // Reset subcategory, brand, and type
//     filterSubCategories(value ? value.id : null); // Fetch subcategories based on selected category
//   }

//   if (name === "subCategory") {
//     // If subCategory is null, clear the brand options
//     if (!value) {
//       console.log("Subcategory is null, clearing brand options");
//       setHeadData([]); // Clear brand options when subcategory is null
//       setTypeData([])
//       setOptions((prev) => ({ ...prev, head: null })); // Clear selected brand
//       setOptions((prev) => ({ ...prev, type: null })); // Clear selected brand
//       return; // Exit early since subcategory is null
//     }

//     // If subCategory is not null, fetch brand options (head data)
//     setOptions((prev) => ({ ...prev, head: null, type: null })); // Reset head and type
//     const selectedCategoryId = options.category ? options.category.id : [];
//     const selectedSubCategoryId = value.id;

//     if (selectedCategoryId && selectedSubCategoryId) {
//       console.log("Fetching brand options for category:", selectedCategoryId, "and subcategory:", selectedSubCategoryId);
//       getHead(selectedCategoryId, selectedSubCategoryId); // Fetch brands (head data) based on category and subcategory
//     }
//   }
// }
function handleOptions(value, name) {
  console.log(name, value, "checks");
  setOptions((prev) => {
    const updatedOptions = { ...prev, [name]: value };

    if (name === "category") {
      const categoryIds = Array.isArray(value) ? value.map((cat) => cat.id) : [];
      const filteredSubData = allSubData.filter((sub) =>
        categoryIds.includes(sub.category_id)
      );
      setSubData(filteredSubData);
    }

    if (name === "subCategory") {
      if (!value || value.length === 0) {
        console.log("Subcategory is null, clearing brand options");
        setHeadData([]);
        setTypeData([]);
        updatedOptions.head = [];
        updatedOptions.type = [];
      } else {
        updatedOptions.head = [];
        updatedOptions.type = [];

        const selectedCategoryIds = prev.category?.map((cat) => cat.id) || [];
        const selectedSubCategoryIds = value.map((sub) => sub.id);

        if (selectedCategoryIds.length && selectedSubCategoryIds.length) {
          console.log(
            "Fetching brand options for categories:",
            selectedCategoryIds,
            "and subcategories:",
            selectedSubCategoryIds
          );
          getHead(selectedCategoryIds, selectedSubCategoryIds);
        }
      }
    }
    return updatedOptions;
  });
}


// function handleOptions(value, name) {
//   setOptions((prev) => ({ ...prev, [name]: value }));

//   if (name === "category") {
//     const categoryIds = Array.isArray(value) ? value.map((cat) => cat.id) : [];
//     const filteredSubData = allSubData.filter((sub) =>
//       categoryIds.includes(sub.category_id)
//     );
//     setSubData(filteredSubData);
//     // setOptions((prev) => ({ ...prev, subCategory: [] })); // Reset subcategory
//   }
// }

function getTypeData(categoryId, subCategoryId, headId) {
 
      axios.get(`/v1/typedesign`)
      // axios.get(`/v1/brand/typedesign/${categoryId}/${subCategoryId}/${headId}`)
          .then(res => {
            setTypeData(res.data);  // Set the received data
            console.log(res.data,"setTypeData"); 
          })
          .catch(err => {
              dispatch(setSnackbar(true, 'error', err.response?.error.message || 'Data Not Found'));
          });
  
}
// function getTypeData(categoryId, subCategoryId, headId) {
//   if (categoryId && subCategoryId && headId) {  // Ensure both categoryId and subCategoryId are available
//       axios.get(`/v1/brand/typedesign`)
//       // axios.get(`/v1/brand/typedesign/${categoryId}/${subCategoryId}/${headId}`)
//           .then(res => {
//             setTypeData(res.data);  // Set the received data
//             console.log(res.data,"setTypeData"); 
//           })
//           .catch(err => {
//               dispatch(setSnackbar(true, 'error', err.response?.error.message || 'Data Not Found'));
//           });
//   } else {
//       // Handle case where either categoryId or subCategoryId is missing
//       // dispatch(setSnackbar(true, 'error', 'Both Category ID and Subcategory ID are required.'));
//   }
// }

console.log(typeData,"typeData");


function filterSubCategories(categoryId) {
  if (categoryId) {
    const filteredSubData = allSubData.filter(
      (sub) => sub.category_id === categoryId
    );
    setSubData(filteredSubData);
  } else {
    setSubData([]);
  }
}
    function handleChange(value, name){
        console.log(name, value)
        if (name === 'fromDate' || name === 'toDate') {
          // If the name is fromDate or toDate, format the date with dayjs
          const formattedDate = dayjs(value).format('YYYY-MM-DD');
          setOptions(prev => ({ ...prev, [name]: formattedDate }));
      } else {
          // For other fields, set directly
          setOptions(prev => ({ ...prev, [name]: value }));
      }
    }
    function getItemData() {
      const allItems = {
        from_date: moment(options.fromDate).format('YYYY-MM-DD'),
        to_date: moment(options.toDate).format('YYYY-MM-DD'),
        customer: cust !== null ? cust.id : outletId,
        // category: options.category === null ? 0 : options.category.id,
        // subcategory: options.subCategory === null ? 0 : options.subCategory.id,
        //working
//              category: options.category.map((cat) => cat.id),
// subcategory: options.subCategory.map((sub) => sub.id),

//  head: options.head.map((head) => head.id),
//   type: options.type.map((type) => type.id),
category: options.category.length ? options.category.map(cat => cat.id) : 0,
subcategory: options.subCategory.length ? options.subCategory.map(sub => sub.id) : 0,
head: options.head.length ? options.head.map(head => head.id) : 0,
type: options.type.length ? options.type.map(type => type.id) : 0,

        // type: options.type === null ? 0 : options.type.id,
        // head: options.head === null ? 0 : options.head.id
      };
    console.log(allItems,"allItems");
    
      axios.post(`/v1/reports/outlet_sales/branchwise/alloutlets/new`, allItems)
        .then(res => {
          const { totalQty, data } = res.data;
          setData(data);
          setTotalQuantity(totalQty);
        })
        .catch(err => {
          setData([]);
          setTotalQuantity(0);
          console.log(err);
          dispatch(setSnackbar(true, 'error', err.response?.data?.errors[0]?.message || 'Error fetching data'));
        });
    }
    function getHead(categoryId, subCategoryId) {
     // Ensure both categoryId and subCategoryId are available
          axios.get(`/v1/Head`)
          // axios.get(`/v1/Head/brand/info/${categoryId}/${subCategoryId}`)
              .then(res => {
                  setHeadData(res.data);  // Set the received data
              })
              .catch(err => {
                  dispatch(setSnackbar(true, 'error', err.response?.error || 'Data Not Found'));
              });
      
  }
  //   function getHead(categoryId, subCategoryId) {
  //     if (categoryId && subCategoryId) {  // Ensure both categoryId and subCategoryId are available
  //         axios.get(`/v1/Head/brand/info`)
  //         // axios.get(`/v1/Head/brand/info/${categoryId}/${subCategoryId}`)
  //             .then(res => {
  //                 setHeadData(res.data);  // Set the received data
  //             })
  //             .catch(err => {
  //                 dispatch(setSnackbar(true, 'error', err.response?.error || 'Data Not Found'));
  //             });
  //     } else {
  //         // Handle case where either categoryId or subCategoryId is missing
  //         // dispatch(setSnackbar(true, 'error', 'Both Category ID and Subcategory ID are required.'));
  //     }
  // }

      function getCategory(){
    axios.get('/v1/categories')
    .then(res=>{
        _.filter(res.data, val=>{
            if(val.is_active){
                 setCatData(res.data)
            }
        })
    })
    .catch(err=>{
        console.log(err)
        dispatch(setSnackbar(true,'error',err.response.data.error))
    })
}
function getSubCategory(){
    axios.get('/v1/subcategories')
    .then(res=>{
            // setSubData(res.data)
            setAllSubData(res.data);
    })
    .catch(err=>{
        console.log(err)
        dispatch(setSnackbar(true,'error',err.response.data.error))
    })
}
function getSupplierData() {
  axios
    .get("/v1/outlet/list/1")
    .then((res) => {
      _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
      setSupplier(res.data);
    })
    .catch((err) => {
      dispatch(setSnackbar(true, "error", err.response.data.error));
    });
}
const exportToExcel = () => {
  const modifiedData = data.map(row => ({
      // 'Product Name': row.pro_name,

      'Category': row.category_name || "All",
      'Sub Category': row.subcategory_name || "All",
      'Brand': row.head_name || "All",
      'Type': row.type_name || "All",
      'Branch': row.fullname || "All",
      'Qty': row.qty,
      // 'Total Amount': row.total_amount
  }));

  // Append the total quantity row
  modifiedData.push({
      // 'Product Name': '',

      'Category': '',
      'Sub Category': '',
      'Branch': '',
      'Type': '',
      'Branch': 'Total Quantity',
      'Qty': totalQuantity,
      // 'Total Amount': ''
  });

  const ws = XLSX.utils.json_to_sheet(modifiedData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'BranchWiseReport');
  XLSX.writeFile(wb, 'BranchWiseReport.xlsx');
};
// const onGenerate = () => {
//   getItemData();
// };
const onGenerate = () => {
  if (!options.category) {
    setCategoryError('Category is required'); // Show error message if category is not selected
    return; // Prevent the function execution if category is not selected
  }

  // If category is selected, call the getItemData function
  getItemData();
};

console.log(data,"datacheck");
useEffect(() => {
  console.log("typeOptions:", typeOptions);  // Check the populated array
}, [typeOptions]);

// Trigger getHead when categoryId or subCategoryId changes
useEffect(() => {
  // if (categoryId && subCategoryId) {
  //   getHead(categoryId, subCategoryId);
  // }
    getHead(categoryId, subCategoryId);
}, [categoryId, subCategoryId]);

// useEffect(() => {
//   const { category, subCategory, head } = options;

//   // Check if all required values are selected before triggering the API call
//   if (category && subCategory && head) {
//     console.log("Calling getTypeData API with", category.id, subCategory.id, head.id);
//     getTypeData(category.id, subCategory.id, head.id); // Make the API call
//   }
// }, [options]); // Trigger whenever options state changes
useEffect(() => {
  const categoryIds = options.category?.map((cat) => cat.id) || [];
  const subCategoryIds = options.subCategory?.map((sub) => sub.id) || [];
  const headIds = options.head?.map((h) => h.id) || [];

  // if (categoryIds.length && subCategoryIds.length && headIds.length) {
  //   console.log("Calling getTypeData API with", categoryIds, subCategoryIds, headIds);
  //   getTypeData(categoryIds, subCategoryIds, headIds); 
  // }
   getTypeData(categoryIds, subCategoryIds, headIds);
}, [options.category, options.subCategory, options.head]);

    useEffect(()=>{
        getCategory()
        getSubCategory()
        getHead()
        getTypeData()
        getSupplierData()
    },[])
    // useEffect(()=>{
    //     getItemData()
    // },[rowsPerPage, page, options , cust])
  return (
    <Fragment>
      <Helmet><title>OverAll BranchWise Sales Reports</title></Helmet>
            <Typography variant="h5">OverAll BranchWise Sales Reports</Typography>
    <Grid container spacing={2} className='p-2 pt-2'>

    <Grid item md={3}>
          <Autocomplete 
            size="small"
            value={cust}
            // options={supplier}
            options={[{id:0 , fullname :"All"} , ...supplier]}

            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname} 
            disabled={roleId != 1 && roleId != 2} 
            renderInput={(params) => <TextField {...params} label="Select Outlet"
            InputProps={{
              ...params.InputProps,
              readOnly: true,
            }}  
            />}
          />
        </Grid>
        <Grid item md={3}>

<Autocomplete 
multiple
size='small'
value={options.category}
options={catData}
getOptionLabel={option=>option.category_name}
onChange={(e,value)=>handleOptions(value,'category')}
renderInput={(params)=>(
<TextField {...params}
label='Category'
error={!!categoryError}
      helperText={categoryError}  // Display the error message
/>
)}
/>


</Grid>
<Grid item md={3}>

   <Autocomplete 
   multiple
size='small'
options={subData}
value={options.subCategory}
disabled={options.category == null}
getOptionLabel={option=>option.subcategory_name}
onChange={(e,value)=>handleOptions(value,'subCategory')}
renderInput={(params)=>(
<TextField {...params}
label='Sub Category'/>
)}
/>
       
</Grid>
    <Grid item md={3}>
      <Autocomplete 
      multiple
        size='small'
        value={options.head}
        options={headData}
        getOptionLabel={option=>option.cateogory_name}
        // getOptionLabel={option => option.head_name}  // Corrected from category_name

        onChange={(e,value)=>handleChange(value,'head')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Brand'/>
          )}
        />
      </Grid>
      <Grid item md={3}>
     <Autocomplete 
     multiple
        size='small'
        value={options.type}
        options={typeData}  // Fallback to empty array if no data

        // options={typeData}
        getOptionLabel={option=>option.type_name}
        onChange={(e,value)=>handleChange(value,'type')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Type Design'/>
          )}
        /> 

{/* <Autocomplete

  options={typeData && typeData.length > 0 ? typeData : []}  // Fallback to empty array if no data
  loading={!typeData}  // Show loading spinner when data is not available
  getOptionLabel={(option) => option.type_name || 'No name available'}
  onChange={(event, newValue) => handleChange(newValue, 'type')}
  renderInput={(params) => <TextField {...params} label="Type Design" />}
  isOptionEqualToValue={(option, value) => option.id === value.id}
/> */}


      </Grid>
      <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(options.fromDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'},
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(options.toDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
    <Button variant='contained' size='small' onClick={onGenerate}>Generate</Button>
</Grid>
    </Grid>
    {/* <Button variant="contained" color="primary" onClick={generateCSV}>Download CSV</Button> */}
    {/* <Paper sx={{ width: '100%', overflow: 'hidden' }}> */}
    <Grid className='text-end my-2'>
    <Button onClick={exportToExcel} variant="outlined" > Export to Excel <SimCardDownloadOutlinedIcon /></Button>
      </Grid>
    <TableContainer className={classes.tblRoot} sx={{height:"500px",overflow:"auto",}}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead className={classes.tblHeader}sx={{position: "sticky",top: 0,}}>
          <TableRow className={classes.tablrow}>
              <TableCell rowSpan={2} sx={{minWidth:70,}}>S.no</TableCell>
              {/* <TableCell  rowSpan={2} sx={{minWidth:250}}>Product Name</TableCell> */}
             
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Category </TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Sub category</TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Brand </TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Type </TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Branch</TableCell>
              <TableCell rowSpan={2} sx={{minWidth:70}}>Qty</TableCell>
             

          </TableRow>

        </TableHead>
        <TableBody>
          {_.map(data , (value, idx) => (
            <TableRow key={idx}  className={classes.tablrow}>
              <TableCell>{idx + 1}</TableCell>
              {/* <TableCell>{value.pro_name || "-"}</TableCell> */}
             
              <TableCell>{value.category_name || "All"}</TableCell>
              <TableCell>{value.subcategory_name || "All"}</TableCell>
              <TableCell>{value.head_name || "All"}</TableCell>
              <TableCell>{value.type_name || "All"}</TableCell>
              <TableCell>{value.fullname || "All"}</TableCell>
              <TableCell>{value.qty || "All"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
                    <TableFooter sx={{ position: "sticky", bottom: 0,backgroundColor: "white" }} >
    <TableRow>
        <TableCell colSpan={6} align="right" style={{ fontWeight: 'bold',fontSize:'14px' }}>
            Total Quantity
        </TableCell>
        <TableCell align="right" style={{ fontWeight: 'bold',fontSize:'14px' }}>
            {totalQuantity}
        </TableCell>
    </TableRow>
</TableFooter>

      </Table>

    </TableContainer>
       
    </Fragment>
  )
}

export default OverAllBranchWiseReport